import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import abs1 from "../../assets/Group39264.png";
import abs2 from "../../assets/white39265.png";
import { postRequest } from "../../utils/axiosrequest";
import { Country } from "../../utils/Country";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header3 from "../../components/Header/Header3";
import "../Login/login.scss";
import { useAuth } from "../../ProtectedRoute/AuthContext";

const SignUp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userMobile = location?.state?.phone_no;
  const { handleLogin } = useAuth();
  const token = "Bearer YmFsbGVyc29mZmljaWFsbGl2ZXdlYnNpdGV0b2tlbjIwMjQ=";

  useEffect(() => {
    document.title = "Sign Up | Ballers";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [Code, setCode] = useState("+91");
  const [hidden, sethidden] = useState(true);
  const [cityHidden, setCityHidden] = useState(true);
  const [countryHidden, setCountryHidden] = useState(true);
  const [User, setUser] = useState({
    member_name: "",
    country_code: Code,
    phone_no: userMobile || "",
    email_id: "",
    DOB: "",
    city: "",
    country: "",
    referral_code: "",
  });
  const [isTrimmed, setIsTrimmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cities = [
    "Bangalore",
    "Chennai",
    "Delhi",
    "Gurgaon",
    "Hyderabad",
    "Mumbai",
    "Noida",
    "Pune",
  ];

  const countries = ["India"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const selectedCountry = Country.find(
      (country) => country.dial_code === User.country_code
    );

    if (name === "phone_no") {
      const maxLength = selectedCountry.phone_length;

      if (value.length >= maxLength) {
        const trimmedValue = value.slice(0, maxLength);
        setUser({ ...User, [name]: trimmedValue });
        setIsTrimmed(true);
      } else {
        setUser({ ...User, [name]: value });
        setIsTrimmed(false);
      }
    } else {
      setUser({ ...User, [name]: value });
    }
  };

  const handleformSubmit = async (e) => {
    e.preventDefault();
    const endpoint = `memberships/member_signup`;
    if (User.phone_no.length < 10) {
      toast.error("Please enter a valid phone number");
      return;
    }

    setIsLoading(true);
    try {
      const res = await postRequest(endpoint, User, token);
      if (res?.data?.msg === "Signup Complete") {
        setUser({
          member_name: "",
          country_code: Code,
          phone_no: userMobile || "",
          email_id: "",
          DOB: "",
          city: "",
          country: "",
          referral_code: "",
        });
        const { access_token, flag } = res?.data?.token;
        handleLogin(access_token, flag);
        navigate("/dashboard/booking");
      } else if (
        res?.response?.data?.detail === "This email ID is already in use."
      ) {
        setUser({
          member_name: "",
          country_code: Code,
          phone_no: userMobile || "",
          email_id: "",
          DOB: "",
          city: "",
          country: "",
          referral_code: "",
        });
      } else if (res?.response?.status === 422) {
        toast.error(res?.response?.data?.detail);
      } else {
        toast.error(res.data);
        setUser({
          member_name: "",
          country_code: Code,
          phone_no: userMobile || "",
          email_id: "",
          DOB: "",
          city: "",
          country: "",
          referral_code: "",
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetOTP = async () => {
    if (!User.phone_no) {
      toast.error("Please enter a phone number first.");
      return;
    }

    try {
      setOTP(["", "", "", "", "", ""]);
      const selectedCountry = Country.find(
        (country) => country.dial_code === User.country_code
      );
      const maxLength = selectedCountry?.phone_length || 10;

      if (User.phone_no.length < maxLength) {
        toast.error(
          `Phone number must be at least ${maxLength} digits to verify.`
        );
        return;
      }
      const otpEndpoint = `memberships/signup_send_otp?country_code=${
        User.country_code
      }&phone_no=${encodeURIComponent(User.phone_no)}`;
      const { data } = await postRequest(otpEndpoint, {}, token);

      if (data?.message === "OTP sent to your registered number") {
        toast.success(data?.message);
        setResendTimer(180);
        setStartTimer(true);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const handleVerifyOtp = async (e) => {
    try {
      const verifyOtpEndpoint = `memberships/signup_verify_otp?country_code=${encodeURIComponent(
        User.country_code
      )}&phone_no=${encodeURIComponent(User.phone_no)}&otp=${encodeURIComponent(
        User.otp
      )}`;

      const otpResponse = await postRequest(verifyOtpEndpoint, {}, token);
      if (otpResponse?.data?.message === "OTP verified successfully") {
        toast.success(otpResponse.data.message);
        setOtpVerified(true);
      } else if (
        otpResponse?.data?.message === "Phone number already verified"
      ) {
        toast.success(otpResponse.data.message);
        setOtpVerified(true);
      } else {
        toast.error(otpResponse.message);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const [resendTimer, setResendTimer] = useState(180);
  const [startTimer, setStartTimer] = useState(false);
  const minutes = Math.floor(resendTimer / 60);
  const seconds = resendTimer % 60;
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const [verifyClicked, setVerifyClicked] = useState(false);
  const [showOTPFilled, setShowOTPFilled] = useState(false);
  const [otpVerifyBtn, setOTPVerifyBtn] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const inputRefs = useRef([]);

  const handleOTPChange = (index, value) => {
    if (index > 4) {
      setOTPVerifyBtn(true);
      setVerifyClicked(false);
    }
    if (!isNaN(value) && value !== "") {
      const newOTP = [...otp];
      newOTP[index] = value;
      setOTP(newOTP);
      setUser({ ...User, otp: newOTP.join("") });
      if (index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "Backspace" && otp[index] !== "") {
      const newOTP = [...otp];
      newOTP[index] = "";
      setOTP(newOTP);
      setUser({ ...User, otp: newOTP.join("") });
    }
  };

  const handleSendOTP = async () => {
    if (verifyClicked) return;

    if (!User.phone_no) {
      toast.error("Please enter a phone number first.");
      return;
    }

    try {
      const selectedCountry = Country.find(
        (country) => country.dial_code === User.country_code
      );
      const maxLength = selectedCountry?.phone_length || 10;

      if (User.phone_no.length < maxLength) {
        toast.error(
          `Phone number must be at least ${maxLength} digits to verify.`
        );
        return;
      }

      const token = "Bearer YmFsbGVyc29mZmljaWFsbGl2ZXdlYnNpdGV0b2tlbjIwMjQ=";
      const otpEndpoint = `memberships/signup_send_otp?country_code=${encodeURIComponent(
        User.country_code
      )}&phone_no=${encodeURIComponent(User.phone_no)}`;

      setVerifyClicked(true);
      const res = await postRequest(otpEndpoint, {}, token);
      if (res?.data === "Phone number already verified.") {
        toast.success(res.data);
        setOtpVerified(true);
        setOTPVerifyBtn(true);
      } else if (res?.data?.message === "OTP sent to your registered number") {
        toast.success(res?.data?.message);
        setShowOTPFilled(true);
        setResendTimer(180);
        setStartTimer(true);
      } else {
        toast.error(res?.response?.data?.detail);
        setVerifyClicked(false);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setVerifyClicked(false);
    }
  };

  useEffect(() => {
    let timer;
    if (startTimer && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [startTimer, resendTimer]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const referralCode = queryParams.get("referralCode");

    if (referralCode) {
      setUser((prevUser) => ({
        ...prevUser,
        referral_code: referralCode,
      }));
    }
  }, [location.search]);

  return (
    <div className="request_section">
      <div className="request_content">
        <Header3 />
        <div className="form">
          <div className="title_signUp">
            <h2>
              <div className="abs1">
                <img src={abs1} alt="" />
              </div>
              One Membership <br /> Unlimited Sports
              <p className="breakLineSignUp"> </p>
            </h2>
            <div className="info">
              <div className="rectangle"></div>
              <p>
                <p className="title2">
                  Play. Compete. Socialize. Anytime. Anywhere.
                </p>
                <div className="abs2">
                  <img src={abs2} alt="" />
                </div>
              </p>
            </div>
          </div>
          <div className="form_wrapper">
            <form onSubmit={handleformSubmit}>
              <p className="loginTxt">Sign Up</p>
              <p className="tagLine">Welcome! Tell us a bit about you.</p>

              <label htmlFor="member_name" className="input-group">
                Name
              </label>
              <input
                type="text"
                id="member_name"
                name="member_name"
                placeholder="Please enter your name"
                value={User.member_name}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="phone_no" className="input-group">
                Phone number
              </label>
              <div className="phonenumber">
                <div className="code" onClick={() => sethidden(!hidden)}>
                  {Code}
                  {hidden ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                  )}
                </div>
                {hidden ? null : (
                  <div className="countrycode">
                    {Country.map((country) => (
                      <div
                        key={country.code}
                        onClick={() => {
                          sethidden((prev) => !prev);
                          setCode(country.dial_code);
                          setUser({
                            ...User,
                            country_code: country.dial_code,
                          });
                        }}
                      >
                        {country.name + " " + country.dial_code}
                      </div>
                    ))}
                  </div>
                )}
                <div className="phoneNumberInputSignUP">
                  <input
                    type="text"
                    id="phone_no"
                    name="phone_no"
                    pattern="[0-9]*"
                    placeholder="Enter your WhatsApp number"
                    value={User.phone_no}
                    onChange={handleInputChange}
                    disabled={otpVerified}
                    autoComplete="off"
                    required
                  />
                  {User.phone_no.length > 9 && isTrimmed ? (
                    <>
                      {otpVerifyBtn ? (
                        <div
                          className={`verifyButtonSignUp ${
                            otpVerified ? "disabled" : ""
                          }`}
                          aria-disabled={otpVerified}
                          onClick={!otpVerified ? handleVerifyOtp : undefined}
                        >
                          {otpVerified ? <p>Verified</p> : <p>Verify</p>}
                        </div>
                      ) : (
                        <div
                          className={`verifyButtonSignUp ${
                            verifyClicked ? "disabled" : ""
                          }`}
                          aria-disabled={verifyClicked}
                          onClick={!verifyClicked ? handleSendOTP : undefined}
                        >
                          Send OTP
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              {showOTPFilled ? (
                <>
                  <label htmlFor="otp" className="input-group email">
                    <div className="otpBottomDivSignUp">
                      OTP
                      {resendTimer === 0 ? (
                        <p className="resendOtp" onClick={handleResetOTP}>
                          Resend OTP
                        </p>
                      ) : (
                        <p className="resendOtp">
                          Resend OTP in {minutes < 10 ? `0${minutes}` : minutes}
                          :{seconds < 10 ? `0${seconds}` : seconds}
                        </p>
                      )}
                    </div>
                  </label>
                  <div className="otp-container">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        ref={(ref) => (inputRefs.current[index] = ref)}
                        type="text"
                        className="otp-input"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOTPChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                      />
                    ))}
                  </div>
                </>
              ) : (
                <></>
              )}

              <label htmlFor="email_id" className="input-group email">
                Email
              </label>
              <input
                type="email"
                id="email_id"
                name="email_id"
                placeholder="Please enter your Email ID"
                value={User.email_id}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="DOB" className="input-group">
                Date of Birth
              </label>
              <input
                type="date"
                id="DOB"
                name="DOB"
                value={User.DOB}
                onChange={handleInputChange}
                required
              />

              <label htmlFor="city" className="input-group">
                City
              </label>
              <div className="phonenumber">
                <div
                  className="cityList"
                  onClick={() => setCityHidden(!cityHidden)}
                >
                  {User.city || "Select City"}
                  {cityHidden ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                  )}
                </div>
                {cityHidden ? null : (
                  <div className="cityListDiv">
                    {cities.map((city) => (
                      <div
                        key={city}
                        onClick={() => {
                          setCityHidden((prev) => !prev);
                          setUser({
                            ...User,
                            city: city,
                          });
                        }}
                      >
                        {city}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <label htmlFor="country" className="input-group">
                Country
              </label>
              <div className="phonenumberNew">
                <div
                  className="cityList"
                  onClick={() => setCountryHidden(!countryHidden)}
                >
                  {User.country || "Select Country"}
                  {countryHidden ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                  )}
                </div>
                {countryHidden ? null : (
                  <div className="countryListDiv">
                    {countries.map((country) => (
                      <div
                        key={country}
                        onClick={() => {
                          setCountryHidden((prev) => !prev);
                          setUser({
                            ...User,
                            country: country,
                          });
                        }}
                      >
                        {country}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <label htmlFor="referral_code" className="input-group referral">
                Referral Code (if any)
              </label>
              <input
                type="text"
                id="referral_code"
                name="referral_code"
                placeholder="Please enter Referral Code"
                value={User.referral_code}
                onChange={handleInputChange}
              />

              <div className="checkBoxDiv">
                <div>
                  <input
                    type="checkbox"
                    name="terms"
                    required
                    value="terms"
                    checked
                  />
                </div>
                <p className="checkBoxTxt">
                  By continuing, you agree to{" "}
                  <a href="/termsandcondition" className="link">
                    Ballers Terms of Use
                  </a>{" "}
                  and{" "}
                  <a href="/privacypolicy" className="link">
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>

              <button type="submit" disabled={isLoading}>
                Sign Up
              </button>

              <p className="signUpTxt">
                Already have an account? 
                <a className="link2" href="/login">
                  Login
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
